module.exports = __webpack_public_path__ + "img/pag-prev.e43319c2.svg";